export default __webpack_public_path__ + "static/signin-modal-vertical-3c0829f4ceae7cd17d78873ead65cb17.jpg";